import Vue from 'vue'
import Vuex from 'vuex'
import BrandModule from './brand.js'
import StoreModule from './store.js'
import StaffModule from './staff.js'
import ManagerModule from './manager.js'
import UserModule from './user.js'
import ErrorModule from './error.js'
import DialogModule from './dialog.js'
import SpinnerModule from './spinner.js'
import AttentionModule from './attention.js'
import ButtonsModule from './buttons.js'
import CheckPageModule from './checkPage.js'
import createPersistedState from 'vuex-persistedstate'
import DailyCheckPageModule from './dailyCheckPage.js'
import PreviewModule from './preview.js'
import DashboardModule from './dashboard.js'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    brand: BrandModule,
    store: StoreModule,
    staff: StaffModule,
    manager: ManagerModule,
    user: UserModule,
    error: ErrorModule,
    dialog: DialogModule,
    spinner: SpinnerModule,
    attention: AttentionModule,
    buttons: ButtonsModule,
    checkPage: CheckPageModule,
    dailyCheckPage: DailyCheckPageModule,
    preview:PreviewModule,
    dashboard:DashboardModule
  },
  plugins: [createPersistedState({
    key: 'haccp',
  })]
})
